import React from 'react'
import { Grid, PageSection as Section, Body } from '@superhi/design'

import { Signature } from './styles'

const GRID_1_SPAN_1: React.ComponentProps<typeof Grid.Cell>['span'] = {
  small: 'full',
  medium: 4,
  large: 6,
}

const WhyOnline: React.FC<React.PropsWithChildren<unknown>> = () => (
  <Section
    title="Why we teach online"
    decorationName="triangle"
    decorationPosition="bottom-right"
    headingLevel={2}
  >
    <Grid>
      <Grid.Cell span={GRID_1_SPAN_1}>
        <Body level="1">
          After teaching at General Assembly, I started a code school in London called Steer. We
          held 5-day courses where students would turn up to our classroom on a Monday morning and
          leave on a Friday evening. I would stand in front of the class teaching the same material,
          week in week out, and over time, I noticed so many of the tiny issues of running a
          classroom-based school.
        </Body>
        <Body level="2">
          It was strange that we were teaching digital skills but not using any of the innovations
          that the same technology gives us. When I left Steer to start SuperHi, I wanted to take
          the best parts of an in-person classroom and use the internet to make the experience even
          better.
        </Body>
        <Body level="2">
          SuperHi is a more affordable, accessible way to learn. You&rsquo;re not paying thousands
          of dollars extra because we rented a classroom in a prime city location. We teach you
          wherever you are&thinsp;&mdash;&thinsp;our students are in 90 countries and 16 time zones!
        </Body>
      </Grid.Cell>
      <Grid.Cell span={GRID_1_SPAN_1}>
        <Body level="2">
          We call it &lsquo;asynchronous learning&rsquo;. You don&rsquo;t need to be there at a
          certain time. Whether you&rsquo;re a quicker or slower learner, learning is at your pace,
          not ours. You can ask any question without feeling embarrassed in front of a group, and
          there&rsquo;s no need to quit your job to skill up.
        </Body>
        <Body level="2">
          Just like our students, the SuperHi team is distributed globally which means we hire the
          best teachers in the world. You&rsquo;re not being taught by some guy who happens to be
          available to stand in front of a class at that time in your city.
        </Body>
        <Body level="2">
          Learning anything creative shouldn&rsquo;t feel like you&rsquo;re in a military bootcamp.
          We get much stronger outcomes than whenever I taught in a classroom previously, and our
          results speak for themselves. Our students have gone on to change careers, increase
          salaries, go freelance and receive top awards for digital design.
        </Body>
        <Body level="2">Learn the SuperHi way.</Body>
        <Body level="2">
          <Signature />
        </Body>
        <Body level="2">Rik Lomas, SuperHi founder + CEO</Body>
      </Grid.Cell>
    </Grid>
  </Section>
)

export default WhyOnline
